import './styles/app.css';

import { createApp } from 'vue';

import { initReveal } from './reveal';
import { islands } from '@app/islands';

/**
 * Insel-Bootstrap.
 *
 * newmanx.de ist keine SPA: jede Route ist eine Twig-Seite, Symfony bleibt Herr
 * über Routing und Zugriff. Vue rendert nur die Stellen, die wirklich
 * interaktiv sind – das Kontaktformular, später zum Beispiel eine Bildergalerie.
 * Alles andere ist server-gerendertes Twig und damit ohne Umwege indexierbar.
 *
 * Markup:
 *     <div data-vue-component="website/ContactForm" data-props="{…}"></div>
 *
 * Jede Insel bekommt ihre **eigene** Vue-App. Es gibt bewusst keinen gemeinsamen
 * Store: die Inseln auf dieser Seite wissen nichts voneinander, und ein Pinia
 * nur für das Farbschema wäre eine Abhängigkeit für vier Zeilen Zustand.
 */
function mountIsland(element) {
    const name = element.dataset.vueComponent;
    const loader = islands[name];

    if (!loader) {
        // Laut scheitern: eine stumm nicht gerenderte Seite kostet bei der Suche
        // mehr Zeit als eine Fehlermeldung in der Konsole.
        console.error(`[newmanx] Unbekannte Vue-Insel "${name}".`, element);

        return;
    }

    let props = {};

    if (element.dataset.props) {
        try {
            props = JSON.parse(element.dataset.props);
        } catch (error) {
            console.error(`[newmanx] data-props von "${name}" ist kein gültiges JSON.`, error);

            return;
        }
    }

    loader()
        .then((module) => {
            createApp(module.default, props).mount(element);

            // Erst jetzt sichtbar machen – verhindert, dass beim Laden kurz das
            // rohe Markup aufblitzt (siehe styles/app.css).
            element.classList.add('is-mounted');
        })
        .catch((error) => {
            console.error(`[newmanx] Insel "${name}" konnte nicht geladen werden.`, error);
        });
}

function boot() {
    // Abschnitte und Karten fahren beim Hereinscrollen auf.
    initReveal();

    document.querySelectorAll('[data-vue-component]').forEach(mountIsland);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
    boot();
}
